import {MOKA_SERVICE_URL, API_URL} from 'api/constants'

export const PROMO_TYPES = `${MOKA_SERVICE_URL}/promo/v1/types`

export const INTERSECTION_ITEM_AND_CATEGORY = `${API_URL}/v1/items/intersect_category_and_item_names`

export const INTERSECTION_ITEM_VARIANTS = `${API_URL}/v1/items/intersect_item_variants`

export const V1_PROMO_BUY_X_GET_Y = `${MOKA_SERVICE_URL}/promo/v1/promos`

export const V1_PROMO_BUY_X_GET_Y_WITH_OUTLETS = `${MOKA_SERVICE_URL}/promo/v1/promos/outlets`

export const DETAIL_PROMO = (promoId) => `${V1_PROMO_BUY_X_GET_Y}/${promoId}`



// WEBPACK FOOTER //
// ./app/api/libraries/promo/constants.js